import getEnvVar from "../utils/getEnvVar";

/**
 * Application-level configuration settings.
 */
export const appConfig = {
	appName: getEnvVar("REACT_APP_NAME", "My Application"),
	appVersion: getEnvVar("REACT_APP_VERSION", "1.0.0"),
	enableAnalytics: getEnvVar("REACT_APP_ENABLE_ANALYTICS", "0") === "1",
	defaultLanguage: getEnvVar("REACT_APP_DEFAULT_LANGUAGE", "en"),
	theme: getEnvVar("REACT_APP_THEME", "light"),
};

export default appConfig;
